<template>
  <v-card>
    <v-container>
      <p class="text-center headline"> {{title}}</p>
      <v-row align="center">
        <v-col cols="10" >
          <v-text-field label="Search" v-model="search" v-if="includeSearch" @input="filterItems"/>
        </v-col>
        <v-col cols="2">
          <slot></slot>
        </v-col>
      </v-row>

      <select-btn v-if="!isSingular"  @selectall="selectAll" @selectnone="selectedItems = []"/>

      <v-row>
        <v-col>
          <v-radio-group
            v-if="isSingular"
            v-model="selectedItem"
            column
          >
            <v-radio
              v-for="(item,key) in itemChoices"
              :key="key"
              :value="`${item[itemvalue]}`"
              :label="`${item[[itemlabel]].toString()}`"
            ></v-radio>
          </v-radio-group>
          <v-checkbox
            v-else
            v-for="item in itemChoices"
            :key="item"
            v-model="selectedItems"
            :value="`${item[itemvalue]}`"
            :label="`${item[[itemlabel]].toString()}`"
            @change="handleChange($event)"
          >
          </v-checkbox>
        </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          text
          @click="handleCancel"
        >
        Cancel
        </v-btn>
        <v-btn
            color="success"
            text
            @click="handleOk"
        >
            Ok
        </v-btn>
      </v-card-actions>
    </v-container>
  </v-card>
</template>

<script>

import SelectBtn from '../btns/SelectBtn.vue'

export default {
  name: 'SelectItemsModal',
  components: {
    SelectBtn
  },
  props: {
    items: Array,
    title: String,
    itemlabel: String,
    itemvalue: String,
    includeSearch: Boolean,
    isSingular: {
      type: Boolean,
      default: false
    },
    filterType: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      search: '',
      selectedItems: [],
      selectedItem: {},
      itemChoices: []
    }
  },
  mounted () {
    this.$emit('modal-mounted', true)
    this.itemChoices = this.$props.items
  },
  methods: {
    handleChange (val) {
      this.selectedItems = val
    },
    selectAll () {

    },
    handleOk () {
      if (!this.isSingular) {
        let obj = {}

        if (this.filterType) {
          obj[`${this.filterType}`] = this.selectedItems
          this.$emit('input', obj)
        } else {
          this.$emit('input', this.selectedItems)
        }
      } else {
        this.$emit('input', this.selectedItem)
      }
      this.$emit('dialog-clicked')
    },
    handleCancel () {
      this.$emit('dialog-clicked')
    },
    filterItems () {
      if (this.search !== '') {
        this.itemChoices = this.itemChoices.filter(item => item[this.itemlabel].toLowerCase().includes(this.search.toLowerCase()))
      } else {
        this.itemChoices = this.$props.items
      }
    }
  }
}
</script>

<style>
</style>
